var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['calendar-events', {loading: _vm.isLoading}]},[_c('div',[_c('FullCalendar',{ref:"fullCalendar",attrs:{"plugins":_vm.calendarPlugins,"header":{
        left: 'prev',
        center: 'title',
        right: 'next',
      },"customButtons":_vm.customButtons,"selectable":true,"fixedWeekCount":false,"eventLimit":false,"eventDataTransform":_vm.eventDataTransform,"eventRender":_vm.eventRender,"events":_vm.events},on:{"dateClick":_vm.dateClick}})],1),(_vm.isLoading)?_c('StLoading'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }